import { checkIsPlatform, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getRadioGroupWidgetStyles = function getRadioGroupWidgetStyles(radioDirection) {
  if (radioDirection === void 0) {
    radioDirection = 'row';
  }
  return StyleSheet.create({
    container: {
      display: 'flex'
    },
    title: {
      marginBottom: tokens.spacing.SPACING_8
    },
    radioButtons: Object.assign({
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap'
    }, radioDirection === 'column' && {
      flexDirection: 'column',
      alignItems: 'stretch',
      flexWrap: 'nowrap'
    }),
    radioButtonContainer: Object.assign({
      flexDirection: 'column'
    }, radioDirection === 'column' && {
      flex: 1
    }),
    radioButtonOuterContainer: {
      flexDirection: 'row'
    }
  });
};
export var getRadioLeftLabelGroupWidgetStyles = function getRadioLeftLabelGroupWidgetStyles(radioDirection, labelPosition) {
  if (radioDirection === void 0) {
    radioDirection = 'row';
  }
  if (labelPosition === void 0) {
    labelPosition = 'right';
  }
  return StyleSheet.create({
    radio: Object.assign(Object.assign({}, labelPosition === 'right' || checkIsPlatform('web') ? {
      marginRight: tokens.spacing.SPACING_16
    } : {
      marginStart: tokens.spacing.SPACING_16
    }), radioDirection === 'column' && {
      marginBottom: tokens.spacing.SPACING_16,
      marginRight: tokens.spacing.SPACING_0,
      marginStart: tokens.spacing.SPACING_0
    }),
    iconSpacer: {
      marginRight: tokens.spacing.SPACING_8
    }
  });
};
export var getRadioInfoTagWidgetStyles = radioButton => {
  var infoTag = {};
  if ((radioButton === null || radioButton === void 0 ? void 0 : radioButton.labelPosition) !== 'left') {
    var marginLeft;
    switch (radioButton === null || radioButton === void 0 ? void 0 : radioButton.size) {
      case 'sm':
        marginLeft = tokens.spacing.SPACING_24;
        break;
      case 'md':
        marginLeft = tokens.spacing.SPACING_28;
        break;
      case 'lg':
        marginLeft = tokens.spacing.SPACING_32;
        break;
      default:
        marginLeft = tokens.spacing.SPACING_24;
        break;
    }
    infoTag = {
      marginLeft: marginLeft
    };
  }
  return StyleSheet.create({
    infoTag: Object.assign(Object.assign({}, infoTag), {
      marginTop: tokens.spacing.SPACING_4
    })
  });
};